<template>
  <div class="overflow-auto pb-base">
    <table class="table-fixed w-auto min-w-full border-none h-0">
      <tbody>
        <tr class="border-solid border-0 border-b-4 border-whiteOverride">
          <th
            v-for="(column, index) in computedColumns"
            :key="index"
            class="row-headers"
          >
            {{ column.heading }}
          </th>
        </tr>
        <tr
          v-for="(row, index) in rows"
          :key="index"
          class="odd:bg-gray-50 hover:bg-gray-100"
        >
          <td
            v-for="(item, index) in row"
            :key="index"
            :title="item && typeof item === 'string'"
            class="font-normal max-w-md truncate border-solid border-0 border-b-4 border-whiteOverride"
            :class="computedColumns[index].class"
          >
            <RendeRer
              :render="computedColumns[index].render"
              :content="item"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// @ts-check
import { defineComponent } from 'vue';

import RendeRer from '@/components/utils/ContentRenderer';

/**
 * @typedef {object} Column
 * @property {string} heading
 * @property {string} [class]
 * @property {(content: string|number) => import('vue').VNode} [render]
 */

export default defineComponent({
  name: 'DataTable',
  components: { RendeRer },
  props: {
    /**
     * Columns contain the column heading as a string or
     * a column object with heading, optional class, and optional render function
     * the render function can be used to customise the columns output
     * @type {import('vue').PropOptions<(string|Column)[]>}
     */
    columns: {
      type: Array,
      required: true,
    },
    /**
     * Rows contain the data
     * @type {import('vue').PropOptions<any[]>}
     */
    rows: {
      type: Array,
      required: true,
    },
  },
  computed: {
    /** @return {Column[]} */
    computedColumns() {
      return this.columns.map((column) => {
        if (typeof column !== 'object') {
          return { heading: column };
        }

        return column;
      });
    },
  },
});
</script>
